import Payment from 'payment';
import APP_DEFAULTS from './constants/app-defaults';
import { PHONE_PREFIX } from './constants';

/**
 * Get the URL parameters
 * source: https://css-tricks.com/snippets/javascript/get-url-variables/
 * @param  {String} url The URL
 * @return {Object}     The URL parameters
 */
const getParamsFromStringURL = (url) => {
    const params = {};

    const parser = document.createElement('a');
    parser.href = url;

    const query = parser.search.substring(1);
    const vars = query.split('&');

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }

    return params;
};

/**
 * Get the query parameters from window location search
 * @return {Map}     The query parameters
 */
const getParamsFromWindowLocationSearch = () => {
    const params = {};

    const query = new URLSearchParams(window.location.search);

    // eslint-disable-next-line no-restricted-syntax
    for (const [param0, param1] of query.entries()) {
        params[param0] = param1;
    }

    return params;
};

const priceFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    // These options are needed to round to whole numbers if that's what you want.
    // minimumFractionDigits: 0,
    // maximumFractionDigits: 0,
});

const getPhone = (value, withMask = false) => {
    if (value) {
        if (withMask) {
            return `${PHONE_PREFIX} ${value.substring(0, 4)} ${value.substring(4)}`;
        }
        return `${PHONE_PREFIX}${value}`;
    }
    return '';
};

// Credit Cards formatters
function clearNumber(value = '') {
    return value.replace(/\D+/g, '');
}

const getClientViewportWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const isMobile = () => getClientViewportWidth() < APP_DEFAULTS.desktopBreakpoint;

const isVisibleInViewport = (elem) => {
    const rect = elem.getBoundingClientRect();
    return (
        rect.top >= 0
        && rect.left >= 0
        && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        && rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
};

export function formatCreditCardNumber(value) {
    if (!value) {
        return value;
    }
    const issuer = Payment.fns.cardType(value);
    const clearValue = clearNumber(value);
    let nextValue;
    switch (issuer) {
    case 'amex':
        nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
            4,
            10,
        )} ${clearValue.slice(10, 15)}`;
        break;
    case 'dinersclub':
        nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
            4,
            10,
        )} ${clearValue.slice(10, 14)}`;
        break;
    default:
        nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
            4,
            8,
        )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
        break;
    }
    return nextValue.trim();
}
export function formatCVC(value, allValues = {}) {
    const clearValue = clearNumber(value);
    let maxLength = 4;
    if (allValues.number) {
        const issuer = Payment.fns.cardType(allValues.number);
        maxLength = issuer === 'amex' ? 4 : 3;
    }
    return clearValue.slice(0, maxLength);
}
export function formatExpirationDate(value) {
    const clearValue = clearNumber(value);
    if (clearValue.length >= 3) {
        if (parseInt(clearValue.slice(0, 2), 10) > 12) {
            return `0${clearValue.slice(0, 1)}/${clearValue.slice(1, 3)}`;
        }
        return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
    }
    return clearValue;
}
export function formatFormData(data) {
    return Object.keys(data).map((d) => `${d}: ${data[d]}`);
}
export function formatMoney(value) {
    return value ? value.replace(/[^.\d]/g, '') : value;
}

export {
    getParamsFromStringURL,
    getParamsFromWindowLocationSearch,
    priceFormat,
    getPhone,
    getClientViewportWidth,
    isMobile,
    isVisibleInViewport,
};



/** WEBPACK FOOTER **
 ** ./src/helper.js
 **/